import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';
// const mime = require('mime');
import * as mime from 'mime';
import * as moment from 'moment';
import { TimeAgoPipe } from 'ngx-pipes';
import { UtilitiesService } from '@app/shared/services/utilities.service';

// import * as mime from 'mime-types';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  data$: Subject<any> = new Subject();
  deletedItem$: Subject<any> = new Subject();
  dashboardErrors$: Subject<any> = new Subject();
  updateProfile$: Subject<any> = new Subject();
  selectePermission$: Subject<any> = new Subject();
  filterOpen$: Subject<any> = new Subject();

  constructor(
    public toastr: ToastrService,
    public dialog: MatDialog,
    public translate: TranslateService,
    public location: Location,
    public timeAgoPipe: TimeAgoPipe,
    public utilitiesService: UtilitiesService
  ) {}

  public moment(date: any = ''): moment.Moment {
    return moment(date);
  }
  public checkFormat(date: string, format: string) {
    return moment(date, format, true).isValid();
  }
  public utcToLocal(date: any) {
    const utc = moment.utc(date).format('YYYY-MM-DD HH:mm:ss');
    const utcDate = moment.utc(utc).toDate();
    const localDate = moment(utcDate)
      .local()
      .format('YYYY-MM-DD HH:mm:ss');

    return localDate;
  }

  public momentFormat(date: any) {
    const convertedDate = this.moment(date).format('YYYY-MM-DD');
    // console.log(convertedDate);
    return convertedDate;
  }

  public momentFormatEn(date: any, dateType: string) {
    const convertedDate = this.moment(date)
      .locale('en')
      .format(dateType);
    return convertedDate;
  }

  public dateToCustomFormat(date: any, format: string) {
    const convertedDate = this.moment(date)
      .lang('de')
      .format(format);
    return convertedDate;
  }
  public replaceDotwWithComa(str: string) {
    return str.replace('.', ',');
  }

  storeItems(data: any) {
    this.data$.next(data);
  }

  handleItemById(data: any) {
    this.deletedItem$.next(data);
  }

  getMimeTypes(extensions: string[]) {
    const extensionsArray: string[] = [];
    extensions.forEach(extension => {
      extensionsArray.push(this.getMimeType(extension));
    });
    return extensionsArray;
  }

  getMimeType(extension: string) {
    return mime.getType(extension);
  }

  getTimeAgoFromDate(date: any, daysCompareTo?: number, dateFormat?: string) {
    const momentDate = moment(date);
    let timeAgo: any = '';
    if (daysCompareTo) {
      const now = moment(new Date());
      const compareTo = now.subtract(daysCompareTo, 'days');

      if (momentDate > compareTo) {
        timeAgo = this.timeAgoPipe.transform(momentDate);
      } else {
        if (dateFormat) {
          timeAgo = momentDate.local().format(dateFormat);
        } else {
          timeAgo = momentDate.local().toDate();
        }
      }
    } else {
      timeAgo = this.timeAgoPipe.transform(momentDate);
    }
    return timeAgo;
  }
}
